import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import TaskNavigation from "@components/Tasks/task-navigation";
import "./map-vender.scss";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
	GetSpecificCheckpointPEComplianceTask,
	UpdateSpecificCheckpointPEComplianceTask,
} from "@services/checkpoint.service";
import { getValue } from "@utils/lodash";
import Loader from "@components/common/Loader";
import InputField from "@_common/InputRuleFeild";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import {
	clientFileUpload,
	clientFileUploads,
} from "@services/client-list.service";
import { toast } from "react-toastify";
import _ from "lodash";
import { useCallbackPrompt } from "../../../../../../prompt/useCallbackPrompt";
import PromptModal from "../../../../../../prompt/modal";
import { handleDownloadOnClick } from "@_common/downloadfile";
import NoAccessPage from "@components/common/NoAccess";
import { todayDate } from "@_common/date-helpers";
import TaskDetailsCommon from "@components/common/TaskDetails";
import CustomFileUpload from "@_common/custom-file-upload";
import { sanitizeInput } from "@_common/dompurify";

export default function ComplianceTaskDetails(props: any) {
	let params = useParams();
	let navigate = useNavigate();
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */
	const simpleValidator = useRef(new SimpleReactValidator());
	const [, forceUpdate] = useState(0);
	const [loading, setLoading] = useState(true);
	const [submitLoading, setSubmitLoading] = useState(false);
	const [data, setData] = useState({});
	const [request, setRequest] = useState<any>({
		follow_up_date: "",
		completion_date: "",
		compliance_status: "",
		work_status: "NEW",
		remarks: "",
		non_compliance_reason: "",
		document_ids: [
			{
				id: "",
			},
		],
	});
	const [dirtyFields, setDirtyFields] = useState<any>({
		follow_up_date: "",
		completion_date: "",
		compliance_status: "",
		work_status: "NEW",
		remarks: "",
		non_compliance_reason: "",
		document_ids: [
			{
				id: "",
			},
		],
	});

	const [uploadedDocuments, setUploadedDocuments] = useState<any>([]);
	const [complianceStatusList] = useState([
		{ value: "PENDING", label: "Pending" },
		{ value: "WORK_IN_PROGRESS", label: "Work In Progress" },
		{ value: "COMPLIED", label: "Complied" },
		{ value: "NON_COMPLIED", label: "Non Complied" },
		{ value: "NOT_APPLICABLE", label: "Not Applicable" },
		{ value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
	]);
	const [workStatusList] = useState([
		{ value: "NEW", label: "New" },
		{ value: "WORK_IN_PROGRESS", label: "Work In Progress" },
		{ value: "COMPLETED", label: "Completed" },
	]);
	const [isLoading, setIsLoading] = useState(true);
	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		if (props.permissionAPITriggered) getData();
	}, [props.permissionAPITriggered]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const getData = async () => {
		try {
			setIsLoading(true);
			let resp = await GetSpecificCheckpointPEComplianceTask(params.taskId);
			if (resp) {
				setData(getValue(resp, `data`, {}));
				setRequest({
					...request,
					follow_up_date: getValue(resp, `data.follow_up_date`, "")
						? new Date(getValue(resp, `data.follow_up_date`, ""))
						: "",
					completion_date: getValue(resp, `data.completion_date`, ""),
					compliance_status: getValue(resp, `data.compliance_status`, ""),
					work_status: getValue(resp, `data.work_status`, ""),
					remarks: getValue(resp, `data.remarks`, ""),
					non_compliance_reason: getValue(
						resp,
						`data.non_compliance_reason`,
						""
					),
					document_ids: getValue(resp, `data.document_ids`, []),
				});
				setDirtyFields({
					...dirtyFields,
					follow_up_date: getValue(resp, `data.follow_up_date`, "")
						? new Date(getValue(resp, `data.follow_up_date`, ""))
						: "",
					completion_date: getValue(resp, `data.completion_date`, ""),
					compliance_status: getValue(resp, `data.compliance_status`, ""),
					work_status: getValue(resp, `data.work_status`, ""),
					remarks: getValue(resp, `data.remarks`, ""),
					non_compliance_reason: getValue(
						resp,
						`data.non_compliance_reason`,
						""
					),
					document_ids: getValue(resp, `data.document_ids`, []),
				});
				setUploadedDocuments(getValue(resp, `data.documents`, []));
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};
	const handleSubmit = async () => {
		const formValid = simpleValidator.current.allValid();
		if (!formValid) {
			simpleValidator.current.showMessages();
			forceUpdate(1);
		} else {
			try {
				let obj = JSON.parse(JSON.stringify(request));
				let payload = {
					follow_up_date: getValue(obj, `follow_up_date`, "")
						? todayDate(getValue(obj, `follow_up_date`, ""))
						: null,
					completion_date:
						getValue(obj, `compliance_status`, "") === "COMPLIED" ||
						getValue(obj, `compliance_status`, "") === "NON_COMPLIED" ||
						getValue(obj, `compliance_status`, "") === "NOT_APPLICABLE" ||
						getValue(obj, `compliance_status`, "") === "PARTIALLY_COMPLIED"
							? getValue(obj, `completion_date`, "")
								? getValue(obj, `completion_date`, "")
								: moment(new Date()).format("YYYY-MM-DD")
							: null,
					compliance_status: getValue(obj, `compliance_status`, ""),
					work_status: getValue(obj, `work_status`, ""),
					remarks: getValue(obj, `remarks`, ""),
					non_compliance_reason: getValue(obj, `non_compliance_reason`, ""),
					document_ids: uploadedDocuments.map((item: object) => ({
						id: getValue(item, `id`, ""),
					})),
				};
				setSubmitLoading(true);
				let resp = await UpdateSpecificCheckpointPEComplianceTask(
					params.taskId,
					payload
				);
				if (resp) {
					setSubmitLoading(false);
					getData();
					confirmNavigation();
					toast.success("Updated successfully");
				} else {
					setSubmitLoading(false);
				}
			} catch (error) {
				setSubmitLoading(false);
			}
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */
	const handleChangeText = (e: any) => {
		const { name, value } = e.target;
		setRequest({
			...request,
			[name]: value,
		});
	};
	const handleUploadDocumnets = async (e: any) => {
		Array.from(e.target.files).forEach(async (item: any) => {
			let formData = new FormData();
			formData.append("file", item);
			try {
				let resp = await clientFileUploads(formData);
				if (resp) {
					uploadedDocuments.push(getValue(resp, `data`, {}));
					setUploadedDocuments([...uploadedDocuments]);
					e.target.value = null;
				} else {
					e.target.value = null;
				}
			} catch (error) {
				e.target.value = null;
			}
		});
	};

	const handleRemoveUploadedFiles = (id: string) => {
		let filtered = uploadedDocuments.filter(
			(item: object) => getValue(item, `id`, "") !== id
		);
		setUploadedDocuments(filtered);
	};
	/* -------------------------------------------------------------------------- */
	/*                                Prompt Section                              */
	/* -------------------------------------------------------------------------- */
	const [isChanged, setIsChanged] = useState(false);
	useEffect(() => {
		setIsChanged(
			_.isEqualWith(request, dirtyFields, (a: any, b: any) => {
				// if both are null or equal to an empty string then they are equal
				if ((_.isNull(a) || a === "") && (_.isNull(b) || b === "")) return true;
			})
		);
	});
	const [showPrompt, confirmNavigation, cancelNavigation]: any =
		useCallbackPrompt(!isChanged);

	// ----------------- Upload section ----------------- //
	const [uploadLoading, setUploadLoading] = useState(false);
	const handleUploadDocuments = async (e: any) => {
		e.preventDefault();
		Array.from(e.target.files).forEach(async (item: any) => {
			let formData = new FormData();
			formData.append("file", item);
			// formData.append("domain_name", getValue(localStorage,`client`,''));
			try {
				setUploadLoading(true);
				let resp = await clientFileUploads(formData);
				if (resp) {
					uploadedDocuments.push(getValue(resp, `data`, {}));
					setUploadedDocuments([...uploadedDocuments]);
					e.target.value = null;
					setUploadLoading(false);
				} else {
					e.target.value = null;
				}
			} catch (error) {
				e.target.value = null;
				setUploadLoading(false);
			}
		});
	};
	const handleDrop = (e: any) => {
		e.preventDefault();
		const files = Array.from(e.dataTransfer.files);
		files.forEach(async (item: any) => {
			let formData = new FormData();
			formData.append("file", item);
			try {
				setUploadLoading(true);
				let resp = await clientFileUploads(formData);
				if (resp) {
					uploadedDocuments.push(getValue(resp, `data`, {}));
					setUploadedDocuments([...uploadedDocuments]);
					e.target.value = null;
					setUploadLoading(false);
				} else {
					e.target.value = null;
				}
			} catch (error) {
				e.target.value = null;
				setUploadLoading(false);
			}
		});
	};
	const handleDragOver = (event: any) => {
		event.preventDefault();
	};
	const disableUpload = () => {};
	return (
		<>
			<Layout>
				{!isLoading &&
				!getValue(props, `subTabPermissionList`, []).includes(
					"activities_pe_compliance"
				) ? (
					<NoAccessPage />
				) : (
					<>
						<PromptModal
							showDialog={showPrompt}
							confirmNavigation={confirmNavigation}
							cancelNavigation={cancelNavigation}
						/>
						<TaskNavigation
							id={params.id}
							checkpoint_id={params.checkpoint_id}
							taskId={params.taskId}
							locationId={params.locationId}
							functionId={params.functionId}
							firstDay={params.firstDay}
							lastDay={params.lastDay}
							handleSubmit={handleSubmit}
							submitLoading={submitLoading}
							save
							isChanged={isChanged}
							permissions={props.permissions}
						/>

						<div className="map-vendor-wrapper map-vendor-wrapper--task-details w-100">
							<div className="map-vendor__details map-vendor__details--task-details d-flex align-items-flex-start px-0 my-0">
								{isLoading || !props.permissionAPITriggered ? (
									<Loader />
								) : (
									<>
										<TaskDetailsCommon
											data={getValue(data, `pe_compliance`, {})}
										/>

										<div className="map-vendor__check map-vendor__check--task-details">
											<h4 className="map-vendor__task-title">
												Task ID - {getValue(data, `compliance_task_id`, "")}
											</h4>

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Legal Due Date
												</label>
												<InputField
													inputType="TEXT"
													placeholder="Enter Legal Due Date"
													className="form-control w-100"
													name="vendor_name"
													id="vendor_name"
													value={moment(
														new Date(getValue(data, `legal_due_date`, ""))
													).format("MMM DD, YYYY")}
													// onChange={(e: any) => handleChangeText(e)}
													label=" Legal Due Date"
													// validator={simpleValidator}
													disabled
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Completion Date
												</label>
												<InputField
													inputType="TEXT"
													placeholder="Completion Date"
													className="form-control w-100"
													name="vendor_name"
													id="vendor_name"
													value={
														getValue(data, `completion_date`, "")
															? moment(
																	new Date(
																		getValue(data, `completion_date`, "")
																	)
															  ).format("MMM DD, YYYY")
															: ""
													}
													// onChange={(e: any) => handleChangeText(e)}
													label="Completion Date"
													// validator={simpleValidator}
													disabled
												/>
											</div>
											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Compliance Status
												</label>
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Enter Compliance Status"
													className="form-control w-100"
													name="compliance_status"
													id="compliance_status"
													value={complianceStatusList.filter(
														(item) =>
															item.value ===
															getValue(request, `compliance_status`, "")
													)}
													options={complianceStatusList}
													onChange={(e: any) =>
														setRequest({
															...request,
															compliance_status: e.value,
														})
													}
													label="Compliance Status"
													// validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Internal Work Status
												</label>
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Enter Work Status"
													className="form-control w-100"
													name="work_status"
													id="work_status"
													value={workStatusList.filter(
														(item) =>
															item.value ===
															getValue(request, `work_status`, "")
													)}
													options={workStatusList}
													onChange={(e: any) =>
														setRequest({
															...request,
															work_status: e.value,
														})
													}
													label="Work Status"
													// validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Followup Date
												</label>
												<InputField
													inputType="DATETYPE-DOB"
													placeholderText="Enter Followup Date"
													className="form-control checkpoint-active-details__form-control w-100"
													name="follow_up_date"
													id="follow_up_date"
													onChange={(e: any) =>
														setRequest({
															...request,
															follow_up_date: e,
														})
													}
													value={getValue(request, `follow_up_date`, "")}
													label="Followup Date"
													// validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group">
												<label
													htmlFor="remarks"
													className="checkpoint-active-details__label"
												>
													Remarks
												</label>
												<InputField
													inputType="TEXT"
													placeholder="Enter Remarks"
													className="form-control w-100"
													name="remarks"
													id="remarks"
													value={getValue(request, `remarks`, "")}
													onChange={(e: any) =>
														setRequest({
															...request,
															remarks: sanitizeInput(e.target.value),
														})
													}
													label="Remarks"
													// validator={simpleValidator}
												/>
											</div>
											{/* <div className="user-details-wrapper__form-group form-group">
										<label className="checkpoint-active-details__label">
											Reason for Non-Compliance 
										</label>
										<InputField
											inputType="TEXT"
											placeholder="Enter Reason for Non-Compliance"
											className="form-control w-100"
											name="non_compliance_reason"
											id="non_compliance_reason"
											value={getValue(request, `non_compliance_reason`, "")}
											onChange={(e: any) =>
												setRequest({
													...request,
													non_compliance_reason: e.target.value,
												})
											}
											label="Reason for Non-Compliance"
											// validator={simpleValidator}
										/>
									</div>
									<div className="user-details-wrapper__form-group form-group">
										<label className="checkpoint-active-details__label">
											Reason for Non-Compliance 
										</label>
										<InputField
											inputType="TEXT"
											placeholder="Enter Reason for Non-Compliance"
											className="form-control w-100"
											name="non_compliance_reason"
											id="non_compliance_reason"
											value={getValue(request, `non_compliance_reason`, "")}
											onChange={(e: any) =>
												setRequest({
													...request,
													non_compliance_reason: e.target.value,
												})
											}
											label="Reason for Non-Compliance"
											// validator={simpleValidator}
										/>
									</div> */}
											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Reason for Non-Compliance
												</label>
												<InputField
													inputType="TEXT"
													placeholder="Enter Reason for Non-Compliance"
													className="form-control w-100"
													name="non_compliance_reason"
													id="non_compliance_reason"
													value={getValue(request, `non_compliance_reason`, "")}
													onChange={(e: any) =>
														setRequest({
															...request,
															non_compliance_reason: sanitizeInput(e.target.value),
														})
													}
													label="Reason for Non-Compliance"
													// validator={simpleValidator}
												/>
											</div>
											<div className="user-details-wrapper__form-group form-group">
												{/* <label className="checkpoint-active-details__label mx-0">
													Upload Proof of Compliance
													<input
														type={"file"}
														onChange={handleUploadDocumnets}
														multiple
														className="d-none"
													/>
													<div className="custom-inputfile d-flex align-items-center">
														<div className="m-auto">
															<p className="custom-inputfile__text">
																Attach Files
															</p>
															<p>
																Files Uploaded (
																{getValue(uploadedDocuments, `length`, 0)})
															</p>
														</div>
													</div>
												</label> */}

												<CustomFileUpload
													handleDrop={handleDrop}
													uploadLoading={uploadLoading}
													disableUpload={disableUpload}
													permissions={getValue(props, `permissions`, [])}
													handleDragOver={handleDragOver}
													handleUploadDocuments={handleUploadDocuments}
												/>
												{getValue(uploadedDocuments, `length`, 0) > 0
													? uploadedDocuments.map(
															(item: object, key: number) => {
																return (
																	<div
																		key={key}
																		className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
																	>
																		<p
																			className="cursor-pointer"
																			onClick={() =>
																				handleDownloadOnClick(
																					getValue(item, `url`, ""),
																					getValue(item, `name`, "")
																				)
																			}
																		>
																			{getValue(item, `name.length`, "") > 30
																				? getValue(item, `name`, "")
																						.substring(0, 30)
																						.concat("...")
																				: getValue(item, `name`, "")}
																		</p>
																		{getValue(props, `permissions`, []).includes("update")&&
																			<img
																				src="/images/close-black.svg"
																				className="img-fluid cursor-pointer"
																				onClick={() =>
																					handleRemoveUploadedFiles(
																						getValue(item, `id`, "")
																					)
																				}
																			/>}
																	</div>
																);
															}
													  )
													: ""}
												<div></div>
											</div>
										</div>
									</>
								)}
							</div>
							<div className="w-100 footer-wrapper--task">
								<img
									src="/images/footer-image.svg"
									className="img-fluid footer-image"
								/>
							</div>
						</div>
					</>
				)}
			</Layout>
		</>
	);
}
